import { render, staticRenderFns } from "./Elenchi.vue?vue&type=template&id=6961149d&scoped=true&"
import script from "./Elenchi.vue?vue&type=script&lang=ts&"
export * from "./Elenchi.vue?vue&type=script&lang=ts&"
import style0 from "./Elenchi.vue?vue&type=style&index=0&id=6961149d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961149d",
  null
  
)

export default component.exports